import { Text } from '@approvalmax/ui/src/components';
import { useAtomValue } from 'jotai';
import { useSelector } from 'modules/react-redux';
import { getNetSuiteContext } from 'pages/requestForm/selectors/netsuite/netSuiteSelectors';
import { memo, useMemo } from 'react';
import { useNetSuiteBillPaymentCreditListFieldSettings } from 'shared/hooks';
import { netSuiteBillPaymentFieldValuesState } from 'shared/states';

import { SectionContainer } from '../../../../components/SectionContainer';
import { useCurrencyPrecision } from '../../hooks';
import { netSuiteBillPaymentCreditListState } from '../../NetSuiteBillPaymentRequestForm/NetSuiteBillPaymentRequestForm.states';
import { StyledBillPaymentLineItemsTable } from '../../NetSuiteRequestForm/NetSuiteRequestForm.styles';
import { getColumnDefs } from './NetSuiteCreditList.config';
import { messages } from './NetSuiteCreditList.messages';

export const NetSuiteCreditList = memo(() => {
    const creditList = useAtomValue(netSuiteBillPaymentCreditListState);
    const fieldValues = useAtomValue(netSuiteBillPaymentFieldValuesState);

    const currencyPrecision = useCurrencyPrecision(fieldValues.currency);

    const { documentFields } = useSelector(getNetSuiteContext);

    const fieldSettings = useNetSuiteBillPaymentCreditListFieldSettings(documentFields);

    const tableDef = useMemo(() => getColumnDefs(fieldSettings, currencyPrecision), [fieldSettings, currencyPrecision]);

    return (
        <SectionContainer title={<Text font='headline'>{messages.sectionName}</Text>} noPadding>
            <StyledBillPaymentLineItemsTable
                columnDefinitions={tableDef}
                lineItems={creditList}
                invalid={false}
                canReorder={false}
                canAddLine={false}
            />
        </SectionContainer>
    );
});

NetSuiteCreditList.displayName = 'NetSuiteCreditList';
